import React, { useEffect, useRef, useState } from "react";
import { getApiCall, postApiCall, postFormApiCall } from "../../utils/api";
import MaterialTable from "material-table";
import tableIcons from "../component/MaterialIcon";
import { ThemeProvider, createTheme } from "@mui/material";
import { Delete, Edit } from "@material-ui/icons";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { Modal } from "@material-ui/core";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import Papa from "papaparse";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const Modules = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const inputRef = useRef(null);

  const [data, setData] = useState([]);
  const [moduleID, setModuleID] = useState("");
  const [loading, setLoading] = useState(false);
  const [classList, setClassList] = useState([]);
  const [className, setClassName] = useState("");
  const [priority, setPriority] = useState("");

  const [moduleTitle, setModuleTitle] = useState("");
  const [moduleTitleHindi, setModuleTitleHindi] = useState("");
  const [moduleTitleMarathi, setModuleTitleMarathi] = useState("");
  const [moduleTitleAssamese, setModuleTitleAssamese] = useState("");
  const [moduleTitleBengali, setModuleTitleBengali] = useState("");
  const [moduleNumber, setModuleNumber] = useState("");
  //   const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const classes = await getApiCall("classes/get-all");
    setClassList(classes.data);

    const res = await getApiCall("module/get-all");
    setData(res.data);
    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setLoading(false);
  };

  //   const handleThumbnailChange = (event) => {
  //     const file = event.target.files[0];
  //     if (file && file.type.startsWith("image/")) {
  //       setImageFile(event.target.files[0]);
  //     } else {
  //       alert("Something went wrong");
  //     }
  //   };


  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const formData = new FormData();

    formData.append("id", moduleID);
    formData.append("class_id", className);
    formData.append("module_name", moduleTitle);
    formData.append("module_name_hindi", moduleTitleHindi);
    formData.append("module_name_marathi", moduleTitleMarathi);
    formData.append("module_name_assamese", moduleTitleAssamese);
    formData.append("module_name_bengali", moduleTitleBengali);
    formData.append("module_number", moduleNumber);
    formData.append("priority", priority);
    let res = {};
    if (moduleID === "") {
      res = await postFormApiCall("module/add", formData);
    } else {
      res = await postFormApiCall("module/update", formData);
    }
    setLoading(false);
    if (res.success === false) {
      return Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });

    // if (fileInputRef.current) {
    //   fileInputRef.current.value = "";
    // }
    // if (imageFileInputRef.current) {
    //   imageFileInputRef.current.value = "";
    // }

    setModuleID("");
    setModuleTitleHindi("");
    setModuleTitleMarathi("");
    setModuleTitleAssamese("");
    setModuleTitleBengali("");
    setClassName("");
    setModuleNumber("");
    // setImageFile(null);
    setLoading(false);
    fetchData();
  };

  const handleStatusChange = async (rowData, newStatus) => {
    const updatedStatus = newStatus === "Active";

    new Swal({
      title: "Are you sure, you want to make it " + newStatus + "?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await postApiCall("module/update-active-status", {
          id: rowData.id,
          status: updatedStatus,
        });
        if (res.success === false) {
          return Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
          });
        }
        Swal.fire({
          title: "Successful",
          text: res.message,
          icon: "success",
        });
        fetchData();
      }
    });
  };

  const columns = [
    { title: "Sl. no", field: "serial", width: "10%" },
    { title: "Class", field: "class_name" },
    {
      title: "Name",
      field: "module_name",
    },
    {
      title: "Status",
      field: "is_active",
      render: (rowData) => (
        <select
          value={rowData.is_active ? "Active" : "Inactive"}
          onChange={(e) => handleStatusChange(rowData, e.target.value)}
        >
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      ),
    },
  ];

  const handleEdit = async (rowData) => {

    setModuleID(rowData.id);
    setClassName(rowData.class_id);
    setPriority(rowData.priority);
    setModuleTitle(rowData.module_name);
    setModuleTitleHindi(rowData.module_name_hindi);
    setModuleTitleMarathi(rowData.module_name_marathi);
    setModuleTitleAssamese(rowData.module_name_assamese);
    setModuleTitleBengali(rowData.module_name_bengali);
    setModuleNumber(rowData.module_number.toString());
    inputRef.current.focus();
    const input = document.getElementById("boardInput");
    input.focus();
  };

  //  const handleDelete = async (rowData) => {
  //     new Swal({
  //       title: "Are you sure?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#d33",
  //       confirmButtonText: "Yes",
  //     }).then(async (result) => {
  //       if (result.isConfirmed) {
  //         const res = await postApiCall("videos/delete", { id: rowData.id });
  //         if (res.success === false) {
  //           return Swal.fire({
  //             title: "Error",
  //             text: res.message,
  //             icon: "error",
  //           });
  //         }
  //         Swal.fire({
  //           title: "Successful",
  //           text: res.message,
  //           icon: "success",
  //         });
  //         fetchData();
  //       }
  //     });
  //   };

  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">Module/Course</h4>
              </div>
              {/* /.col */}
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Module/Course</li>
                </ol>
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {/* left column */}
              <div className="col-md-12 mt-4">
                {/* general form elements */}
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">
                      {moduleID === "" ? "Add" : "Edit"} Modules/Course
                    </h3>
                  </div>
                  <form onSubmit={handleSubmit} enctype="multipart/form-data">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {moduleID === "" ? "Select" : "Edit"} Class
                            </label>
                            <select
                              class="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => {
                                setClassName(e.target.value);
                              }}
                              required
                              value={className}
                              name="class_id"
                            >
                              <option value="" disabled selected>
                                Select an option
                              </option>
                              {classList.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {moduleID === "" ? "Add" : "Edit"} English Title 
                            </label>
                            <input
                              type="text"
                              onChange={(e) => setModuleTitle(e.target.value)}
                              className="form-control"
                              id="boardInput"
                              placeholder="Enter title"
                              ref={inputRef}
                              value={moduleTitle}
                              name="title"
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {moduleID === "" ? "Add" : "Edit"} Hindi Title
                            </label>
                            <input
                              type="text"
                              onChange={(e) => setModuleTitleHindi(e.target.value)}
                              className="form-control"
                              id="boardInput"
                              placeholder="Enter title"
                              ref={inputRef}
                              value={moduleTitleHindi}
                              name="title"
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {moduleID === "" ? "Add" : "Edit"} Marathi Title
                            </label>
                            <input
                              type="text"
                              onChange={(e) => setModuleTitleMarathi(e.target.value)}
                              className="form-control"
                              id="boardInput"
                              placeholder="Enter title"
                              ref={inputRef}
                              value={moduleTitleMarathi}
                              name="title"
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {moduleID === "" ? "Add" : "Edit"} Assamese Title
                            </label>
                            <input
                              type="text"
                              onChange={(e) => setModuleTitleAssamese(e.target.value)}
                              className="form-control"
                              id="boardInput"
                              placeholder="Enter title"
                              ref={inputRef}
                              value={moduleTitleAssamese}
                              name="title"
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">
                              {moduleID === "" ? "Add" : "Edit"} Bengali Title
                            </label>
                            <input
                              type="text"
                              onChange={(e) => setModuleTitleBengali(e.target.value)}
                              className="form-control"
                              id="boardInput"
                              placeholder="Enter title"
                              ref={inputRef}
                              value={moduleTitleBengali}
                              name="title"
                            />
                          </div>
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label for="selectInput">
                              {moduleID === "" ? "Select" : "Edit"} Priority
                            </label>
                            <select
                              className="custom-select form-select rounded-0"
                              id="selectInput"
                              onChange={(e) => setPriority(e.target.value)}
                              required
                              value={priority}
                              name="priority"
                            >
                              <option value="" disabled>
                                Select an option
                              </option>
                              {Array.from({ length: 20 }, (_, i) => i + 1).map(
                                (num) => (
                                  <option key={num} value={num}>
                                    {num}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        </div>

                        {/* <div className="col-md-6 col-sm-12">
                          <div class="form-group">
                            <label htmlFor="classInput">
                              {moduleID === "" ? "Add" : "Edit"} Thumbnail
                            </label>
                            <div class="input-group">
                              <input
                                type="file"
                                accept="image/*"
                                ref={imageFileInputRef}
                                onChange={(e) => handleThumbnailChange(e)}
                                // required={moduleID === "" ? true : false}
                              />
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary">
                        {moduleID === "" ? "Submit" : "Update"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /.card */}
            </div>
            {/*/.col (right) */}
          </div>
          {/* /.row */}
        </section>

        <section className="content mt-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                      icons={tableIcons}
                      title="Modules/Course"
                      columns={columns}
                      data={data}
                      onRowClick={(evt, selectedRow) =>
                        setSelectedRow(selectedRow.tableData.id)
                      }
                      options={{
                        exportButton: true,
                        exportCsv: (columns, data) => {
                          // Extract column titles
                          const columnTitles = columns.map((col) => col.title);

                          // Build CSV rows
                          const csvData = data.map(
                            (row) => columns.map((col) => row[col.field] ?? "") // handle undefined fields
                          );

                          // Combine into a full CSV
                          const csv = Papa.unparse({
                            fields: columnTitles,
                            data: csvData,
                          });

                          // Create and trigger file download
                          const blob = new Blob([csv], {
                            type: "text/csv;charset=utf-8;",
                          });
                          const url = URL.createObjectURL(blob);
                          const link = document.createElement("a");
                          link.href = url;
                          link.setAttribute(
                            "download",
                            "modules.csv"
                          );
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        },
                        exportPdf: (columns, data) => {
                          const doc = new jsPDF();
                          const tableColumnTitles = columns.map(
                            (col) => col.title
                          );
                          const tableRows = data.map((row) =>
                            columns.map((col) => row[col.field] ?? "")
                          );

                          autoTable(doc, {
                            head: [tableColumnTitles],
                            body: tableRows,
                            styles: { fontSize: 8 },
                            headStyles: { fillColor: [0, 123, 255] },
                          });

                          doc.save("modules.pdf");
                        },
                        actionsColumnIndex: -1,
                        headerStyle: {
                          backgroundColor: "rgb(0 123 255)",
                          color: "#FFF",
                          fontSize: 18,
                        },
                        rowStyle: (rowData, index) => ({
                          backgroundColor:
                            selectedRow === rowData.tableData.id
                              ? "#d3d4d1"
                              : index % 2 !== 0
                              ? "#EEE"
                              : "#FFF",
                        }),
                      }}
                      actions={[
                        {
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Edit />
                            </span>
                          ),
                          tooltip: "Edit",
                          onClick: (event, rowData) => handleEdit(rowData),
                        },
                        // (rowData) => ({
                        //   icon: () => (
                        //     <span style={{ color: "#5656ce" }}>
                        //       <Delete />
                        //     </span>
                        //   ),
                        //   tooltip: "Delete",
                        //   onClick: (event, rowData) => handleDelete(rowData),
                        // }),
                      ]}
                    />
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
    </div>
  );
};

export default Modules;
